import { Fragment, type ReactNode } from 'react';
import { Link } from '@/primitives';
import { externalLinkAttributes } from '@/utils/externalHref';
import type { TextSegment } from './saleLinks';

export function ExternalLink({
  href,
  children,
}: {
  href: string;
  children: ReactNode;
}) {
  return (
    <Link
      href={href}
      {...externalLinkAttributes(href)}
      sx={{ overflowWrap: 'anywhere' }}
    >
      {children}
    </Link>
  );
}

/** Renders `linkifyText` / `linkifyField` output inline. */
export function LinkifiedText({ segments }: { segments: TextSegment[] }) {
  return (
    <>
      {segments.map((segment, index) =>
        segment.kind === 'link' ? (
          <ExternalLink key={index} href={segment.href}>
            {segment.text}
          </ExternalLink>
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        ),
      )}
    </>
  );
}
